import { CoreHelperUtil } from '@reown/appkit-core'
import { html } from 'lit'

// add selectWalletTemplate to copyTemplate in <w3m-connecting-wc-qrcode />
// https://github.com/reown-com/appkit/blob/9bf27b65a75c2fd6a83b5668b223a04a58ee7609/packages/scaffold-ui/src/partials/w3m-connecting-wc-qrcode/index.ts#L97
export const registerSelectWalletButton = () =>
  customElements
    .whenDefined('w3m-connecting-wc-qrcode')
    .then(W3mConnectingWcQrcode => {
      if (typeof W3mConnectingWcQrcode.prototype.copyTemplate !== 'function')
        throw new TypeError(
          'copyTemplate is missing in <w3m-connecting-wc-qrcode />'
        )

      W3mConnectingWcQrcode.prototype.copyTemplate = function () {
        return html`${this.copyTemplateOriginal()}${this.selectWalletTemplate()}`
      }

      W3mConnectingWcQrcode.prototype.copyTemplateOriginal = function () {
        const inactive = !this.uri || !this.ready

        return html`<wui-link
          .disabled=${inactive}
          @click=${this.onCopyUri}
          color="fg-200"
          data-testid="copy-wc2-uri"
        >
          <wui-icon
            size="xs"
            color="fg-200"
            slot="iconLeft"
            name="copy"
          ></wui-icon>
          Copy link
        </wui-link>`
      }

      W3mConnectingWcQrcode.prototype.selectWalletTemplate = function () {
        const isSupported =
          CoreHelperUtil.isMobile() &&
          (CoreHelperUtil.isAndroid() || !CoreHelperUtil.isSafari())
        if (!isSupported) return null

        const inactive = !this.uri || !this.ready

        return html`<wui-link
          .disabled=${inactive}
          @click=${this.onSelectWallet}
          color="fg-200"
          data-testid="copy-wc2-uri"
        >
          Select Wallet
        </wui-link>`
      }

      W3mConnectingWcQrcode.prototype.onSelectWallet = function () {
        const isSupported =
          CoreHelperUtil.isMobile() &&
          (CoreHelperUtil.isAndroid() || !CoreHelperUtil.isSafari())
        const inactive = !this.uri || !this.ready

        if (!isSupported || inactive) return

        console.log('onSelectWallet', this.uri, this.ready)
        console.dir(this)

        CoreHelperUtil.openHref(this.uri, '_self')
      }
    })
